import t from"react";import{MdIcon as o}from"./MdIcon.js";import{mdiYoutube as e}from"@mdi/js";const r=({id:r="youtube",title:i="YouTube",...m})=>t.createElement(o,{id:r,title:i,path:e,...m});export{r as YoutubeIcon};
